import { render, staticRenderFns } from "./ChatTabs.vue?vue&type=template&id=619cb95a&scoped=true&"
import script from "./ChatTabs.vue?vue&type=script&lang=js&"
export * from "./ChatTabs.vue?vue&type=script&lang=js&"
import style0 from "./ChatTabs.vue?vue&type=style&index=0&id=619cb95a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619cb95a",
  null
  
)

export default component.exports